module.exports = {"TXTCLI_Please_enter_a_valid_SSN":{"id":"TXTCLI_Please_enter_a_valid_SSN","defaultMessage":"Te rugăm să introduci un SSN valid"}}